import { render, staticRenderFns } from "./AccessoriesDrawer.vue?vue&type=template&id=5aa41550&scoped=true"
import script from "./AccessoriesDrawer.vue?vue&type=script&lang=js"
export * from "./AccessoriesDrawer.vue?vue&type=script&lang=js"
import style0 from "./AccessoriesDrawer.vue?vue&type=style&index=0&id=5aa41550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa41550",
  null
  
)

export default component.exports